import React from 'react';

export default ({ children }) => <span className="button-group">{children}</span>;
